import _ from "lodash";
import RequestError from "./RequestError";
import amProxyUrl from "./AmProxyUrl";
import api from "@/api";

/**
 * @typedef RequestConfig
 * @prop {string} path
 * @prop {string} method
 * @prop {Object} [params]
 * @prop {any} [data]
 */

export default {
  addPlayout,
	getPlayoutConfig,
  savePlayoutConfig
};

/**
 * @param {string} name
 * @param {string} mode
 * @param {string} timeZone
 * @param {number} [fps]
 * @param {string} [resolution] e.g. "1280x720"
 */
function addPlayout(name, mode, timeZone, fps, resolution) {
	const config = {
		mode,
		timeZone,
	};
	if (fps != null) config.fps = fps;
	if (resolution != null) config.resolution = resolution;
	return makeRequest({
		path: '/streams/deploy',
		method: 'post',
		data: {
			stream: {
				name,
				type: 'tvplayout',
				config,
			}
		}
	});
}

/**
 * @param {string} playoutId
 */
async function getPlayoutConfig(playoutId) {
	return makeRequest({
		path: `/streams/${playoutId}/tvplayout/config`,
		method: 'get',
	});
}


/**
 * @param {string} playoutId
 * @param {object} config
 */
async function savePlayoutConfig(playoutId, config) {
	return makeRequest({
		path: `/streams/${playoutId}/tvplayout/config`,
		method: 'put',
    data: {
      mode: config.mode,
      datetime: config.datetime,
      timeZone: config.timeZone,
      destination: config.destination,
      // Strip the client-only `_uid` (used purely for stable Vue list keys) so
      // it never leaks into the persisted config.
      playlist: Array.isArray(config.playlist)
        ? config.playlist.map((item) => _.omit(item, "_uid"))
        : config.playlist,
      settings: config.settings,
    }
	});
}

/**
 * @param {RequestConfig|string} reqConfig
 */
async function makeRequest(reqConfig, preventProxy, throwReal) {
  if (typeof reqConfig === "string") {
    reqConfig = {
      path: reqConfig,
    };
  }

  if (preventProxy !== true) {
    reqConfig = amProxyUrl(reqConfig, process.env.VUE_APP_VOD_API_BASE_URL);
  }

  reqConfig.url = reqConfig.path;

  let res;
  try {
    res = await api.request(reqConfig);
  } catch (err) {
    if (throwReal) {
      throw err;
    }
    const edata = _.get(err, "response.data");
    throw new RequestError(edata);
  }

  return res && res.data;
}
